import animatednavigation from "../images/portImages/animated-navigation.png";
import animatedwebtemplate from "../images/portImages/animated-web-template.png";
import backgroundgenerator from "../images/portImages/backgroundgenerator.png";
import contactManagerApp from "../images/portImages/ContactManagerApp.png";
import cssgridflexbox from "../images/portImages/cssgridflexbox.png";
import facerecognitionapp from "../images/portImages/facerecognitionapp.png";
import infiniteimagescroll from "../images/portImages/infiniteimagescroll.png";
import joketeller from "../images/portImages/joke-teller.png";
import lifeinwild from "../images/portImages/lifeinwild.png";
import lightdarkmode from "../images/portImages/lightdarkmode.png";
import musicplayer from "../images/portImages/musicplayer.png";
import pictureinpicture from "../images/portImages/pictureinpicture.png";
import preetisblog from "../images/portImages/preetisblog.png";
import quotegenerator from "../images/portImages/quotegenerator.png";
import robotfriends from "../images/portImages/robotfriends.png";
import starwarsapiinfowebpage from "../images/portImages/starwarsapiinfowebpage.png";
import todolist from "../images/portImages/todolist.png";
import digitalclock from "../images/portImages/digitalclock.png";
import portfoliotemplate from "../images/portImages/portfoliotemplate.png";
import resorthotel from "../images/portImages/resorthotel.png";
import circleincircle from "../images/portImages/circle-in-circle-cssart.png";
import clouds from "../images/portImages/clouds-cssart.png";
import icecreamcupcake from "../images/portImages/icecream-cupcake.png";

const portfolios = [
  {
    id: 1,
    category: "React",
    image: resorthotel,
    link1: "https://github.com/preeti-mammen/grand-hotel-reactapp",
    link2: "https://dreamy-lovelace-5fa9de.netlify.app",
    title: "Hotel Website",
    text: "React Based Hotel Website",
  },
  {
    id: 3,
    category: "React",
    image: facerecognitionapp,
    link1: "https://github.com/preeti-mammen/facerecognition_finalproject",
    link2: "https://face-recoginition-app.herokuapp.com/",
    title: "Face Recognition",
    text: "Uses Clarifai APIs for Face Recognition and a score is given to the user",
  },
  {
    id: 2,
    category: "React",
    image: portfoliotemplate,
    link1: "https://github.com/preeti-mammen/portfolio-sample-react",
    link2: "https://boring-joliot-960e47.netlify.app/",
    title: "Portfolio Template",
    text: "Simple Portfolio Template which uses Tachyons for CSS rendering",
  },
  {
    id: 4,
    category: "React",
    image: robotfriends,
    link1: "https://github.com/preeti-mammen/robofriends_reactapp",
    link2: "https://nervous-goldwasser-c11861.netlify.app/",
    title: "Robot Friends",
    text: "List robots as cards and filters robot cards",
  },

  {
    id: 5,
    category: "Javascript",
    image: digitalclock,
    link1: "https://github.com/preeti-mammen/digital-clock",
    link2: "https://nervous-volhard-9a0587.netlify.app/",
    title: "Digital Clock",
    text: "Simple Digital Clock with Date and Time display",
  },
  {
    id: 6,
    category: "Javascript",
    image: quotegenerator,
    link1: "https://github.com/preeti-mammen/quote-generator",
    link2: "https://gifted-ptolemy-10fcd5.netlify.app/",
    title: "Quote Generator",
    text: "Displays random quote on launch",
  },
  {
    id: 7,
    category: "Javascript",
    image: musicplayer,
    link1: "https://github.com/preeti-mammen/music-player",
    link2: "https://happy-kirch-8e3ab2.netlify.app/",
    title: "Music Player",
    text: "This application uses Javascript to Design a Music Player with controls.",
  },
  {
    id: 8,
    category: "Javascript",
    image: pictureinpicture,
    link1: "https://github.com/preeti-mammen/picture-in-picture",
    link2: "https://romantic-hoover-314fc0.netlify.app",
    title: "Picture-In-Picture",
    text: "Plays the video on the application screen.Please note: This works only for Desktop and not on Mobile Devices as of now",
  },
  {
    id: 9,
    category: "Javascript",
    image: infiniteimagescroll,
    link1: "https://github.com/preeti-mammen/infinite-image-scroll",
    link2: "https://frosty-neumann-253d62.netlify.app",
    title: "Infinite Image Scroll",
    text: "Calls Unsplash API which displays random photos on launch. Dynamically loads more photos on scrolling to the bottom of the screen",
  },
  {
    id: 10,
    category: "Javascript",
    image: animatednavigation,
    link1: "https://github.com/preeti-mammen/animated-navigation",
    link2: "https://nifty-aryabhata-67b7bc.netlify.app/",
    title: "Animated Navigation",
    text: "Simple Animated Navigation",
  },
  {
    id: 11,
    category: "Javascript",
    image: backgroundgenerator,
    link1: "https://github.com/preeti-mammen/background-generator",
    link2: "https://practical-bohr-43cf62.netlify.app/",
    title: "Background Generator",
    text: "Generates random background colors with the click of a button",
  },
  {
    id: 12,
    category: "Javascript",
    image: lightdarkmode,
    link1: "https://github.com/preeti-mammen/light-dark-mode",
    link2: "https://ecstatic-cori-9de207.netlify.app/",
    title: "Light/Dark Mode",
    text: "Toggling in Light/Dark Mode and using local storage to keep the state of the toggle selected",
  },
  {
    id: 13,
    category: "Javascript",
    image: joketeller,
    link1: "https://github.com/preeti-mammen/joke-teller",
    link2: "https://focused-hugle-6b6e80.netlify.app/",
    title: "Joke Teller",
    text: "This application uses Javascript to call Text to Speech API & Joke API to speak out random Jokes",
  },
  {
    id: 14,
    category: "Javascript",
    image: todolist,
    link1: "https://github.com/preeti-mammen/to-do-list-javascript",
    link2: "https://upbeat-raman-5e345c.netlify.app",
    title: "To Do List",
    text: "Add/Delete Item to the list with a strikethrough functionality",
  },
  {
    id: 15,
    category: "Javascript",
    image: starwarsapiinfowebpage,
    link1: "https://github.com/preeti-mammen/display_api_info_webpage",
    link2: "https://sad-leavitt-f54d3d.netlify.app",
    title: "Star Wars API Info",
    text: "Uses the APIs from Star Wars (dummy APIs) and pulls the info and displays them on the webpage",
  },
  {
    id: 16,
    category: "HTML/CSS",
    image: animatedwebtemplate,
    link1: "https://github.com/preeti-mammen/animated-template",
    link2: "https://vigorous-mcclintock-8c5434.netlify.app/",
    title: "Animated Web Template",
    text: "Uses Tailwind Starter Kit from Creative Tim and Animate On Scroll Library to create an animated loading of components for this website",
  },
  {
    id: 17,
    category: "HTML/CSS",
    image: lifeinwild,
    link1: "https://github.com/preeti-mammen/life-in-the-wild",
    link2: "https://trusting-lewin-e067e0.netlify.app",
    title: "Life in the Wild",
    text: "Simple Responsive Website using Flexbox concept",
  },
  {
    id: 18,
    category: "HTML/CSS",
    image: preetisblog,
    link1: "https://github.com/preeti-mammen/newWebSiteSample",
    link2: "https://inspiring-brahmagupta-842c69.netlify.app/",
    title: "Blog Website",
    text: "Website done as part of coding challenge #8 hosted by Zero to Mastery",
  },
  {
    id: 19,
    category: "HTML/CSS",
    image: cssgridflexbox,
    link1: "https://github.com/preeti-mammen/css-grid-flexbox-sample",
    link2: "https://lucid-ritchie-9056ad.netlify.app/",
    title: "CSS Grid and Flexbox",
    text: "Modified version for website done via following the Zero To Mastery Web Developer course using CSS grid and Flexbox concepts",
  },

  {
    id: 20,
    category: "React",
    image: contactManagerApp,
    link1: "https://github.com/preeti-mammen/Contact-App",
    link2: "https://silly-borg-b401ef.netlify.app/",
    title: "Contact Manager App",
    text: "Contact manager app which uses local storage to store the name and email address of the contacts",
  },
  {
    id: 21,
    category: "CSS Arts",
    image: circleincircle,
    link1: "https://github.com/preeti-mammen/circle-in-circle-cssart",
    link2: "https://boring-bassi-17e76c.netlify.app/",
    title: "Circle In Circle",
    text: "Circle within circle using html and css",
  },
  {
    id: 22,
    category: "CSS Arts",
    image: clouds,
    link1: "https://github.com/preeti-mammen/clouds-css-art",
    link2: "https://gracious-volhard-a278c0.netlify.app/",
    title: "Rainy Clouds",
    text: "Clouds with rain animation created in html and css",
  },
  {
    id: 23,
    category: "CSS Arts",
    image: icecreamcupcake,
    link1: "https://github.com/preeti-mammen/cupcake-icecream-cssart",
    link2: "https://hardcore-goldwasser-6285ef.netlify.app",
    title: "Icecream & Cupcake",
    text: "Icecream and cupcake created in html and css",
  },
];

export default portfolios;
